import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RippleModule } from 'primeng/ripple';
import { AuthService } from '@/app/pages/service/auth/auth.service';
import { PerfilService } from '@/app/pages/service/perfil/perfil.service';
import { RouterLink } from '@angular/router';

@Component({
    selector: '[app-profile]',
    standalone: true,
    imports: [CommonModule, RippleModule, RouterLink],
    template: `
        @if (usuarioAdmin) {
            <button pRipple [class]="buttonClass" [routerLink]="['/configuracao/controle-acesso']">
                <i class="pi pi-cog"></i>
                <span>Controle de Acesso</span>
            </button>
            <button pRipple [class]="buttonClass" [routerLink]="['/configuracao/configuracao-empresa']">
                <i class="pi pi-file"></i>
                <span>Configuração</span>
            </button>
            <button pRipple [class]="buttonClass" [routerLink]="['/configuracao/cadastro-empresas']">
                <i class="pi pi-comments"></i>
                <span>Empresas</span>
            </button>
            <button pRipple [class]="buttonClass"  [routerLink]="['/configuracao/cadastro-usuarios']">
                <i class="pi pi-at"></i>
                <span>Usuários</span>
            </button>
        }
        <button pRipple [class]="buttonClass"  [routerLink]="['/configuracao/perfil-usuario']">
            <i class="pi pi-user"></i>
            <span>Perfil</span>
        </button>
        <button pRipple [class]="buttonClass" (click)="logout()" [routerLink]="['/auth/login']">
            <i class="pi pi-sign-in"></i>
            <span>Sair</span>
        </button>
    `,
    host: {
        class: 'z-30 p-2 space-y-2 rounded-2xl bg-surface-0 dark:bg-surface-950 shadow-[0px_129.205px_36.493px_0px_rgba(44,54,87,0.00),_0px_82.849px_33.534px_0px_rgba(44,54,87,0.01),_0px_46.356px_27.616px_0px_rgba(44,54,87,0.03),_0px_20.712px_20.712px_0px_rgba(44,54,87,0.05),_0px_4.932px_11.836px_0px_rgba(44,54,87,0.06)] dark:shadow-stroke'
    }
})
export class AppProfile {
    styleClass = input<string>('');

    usuario: any;
    usuarioAdmin: any;

    readonly buttonClass = 'w-full px-3 py-2 rounded-lg flex items-center gap-2 font-medium text-surface-500 hover:text-surface-950 dark:hover:text-surface-0 hover:bg-surface-100 dark:hover:bg-surface-800 transition-colors duration-150';

    
    constructor(
        private _authService: AuthService,
        private _perfilService: PerfilService
    ) {}
    
    ngOnInit() {
        this.carregarPerfil();
    }

    carregarPerfil() {
        this.usuario = this._authService.getUserLogged().result;

        if (this.usuario) {
            this._perfilService.listarPorId(this.usuario.perfilId).subscribe({
                next: (data) => {
                    if (data.result.nome == 'Admin' || data.result.nome == 'Administrador') {
                        this.usuarioAdmin = true;
                    }
                }, error: (err) => {

                }
            })
        }
    }

    logout() {
        this._authService.logout();
    }
}